/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import {
  Box,
  Checkbox,
  Chip,
  TableCell,
  TableRow,
  Tooltip,
} from '@mui/material';
import React from 'react';
import moment from 'moment';
import {
  Add,
  AutoAwesome,
  FmdBad,
  NotificationsActive,
  Task,
  Today,
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import {
  sortBy,
  uniqBy,
} from 'lodash';
import { getColorHexForImportance } from '../../../../../../utils/enumHelper';
import { setSelectedBarnHorse } from '../../../../../../redux/app/actions';
import Horse from '../../../../../Horse';
import TaskOverviewCell from '../TaskOverviewCell';
import {
  blueGrey,
  primary,
  secondary,
} from '../../../../../../utils/brandColors';
import { getDayOfWeekFromNumber } from '../../../../../../utils/barnBoardHelper';

const customComparator = (prevProps, nextProps) => JSON.stringify(prevProps.barnHorse) === JSON.stringify(nextProps.barnHorse)
  && JSON.stringify(prevProps.boardSuggestionsKey) === JSON.stringify(nextProps.boardSuggestionsKey)
  && JSON.stringify(prevProps.overviewKey) === JSON.stringify(nextProps.overviewKey)
  && prevProps.dayAsDate === nextProps.dayAsDate
  && prevProps.selectedDay === nextProps.selectedDay
  && prevProps.planningMode === nextProps.planningMode
  && prevProps.locationIndicator === nextProps.locationIndicator
  && JSON.stringify(prevProps.selectedBarnHorses) === JSON.stringify(nextProps.selectedBarnHorses)
  && JSON.stringify(prevProps.horseLocationsByTagKey) === JSON.stringify(nextProps.horseLocationsByTagKey)

function breakUpCamelCase(str) {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}
export const TaskCalendarOverviewHorseRow = React.memo(({
  actionCompleteCallback,
  barnHorse,
  boardSuggestionsKey,
  classes,
  dispatch,
  fullScreen,
  handleCalendarEventItemClick,
  handleOverviewItemClick,
  handleOverviewItemTaskStateChangeClick,
  navigate,
  overviewKey,
  selectedBarnHorses,
  selectedDay,
  setOpenQuickSelectMenu,
  setSelectedBarnHorses,
  setSelectedSlot,
  theme,
  todayTimestamp,
  locationIndicator,
  planningMode,
  handleOpenScheduleModal,
}) => {
  const planningDayOfWeek = planningMode && selectedDay && moment(new Date(parseInt(selectedDay, 10))).day();

  const [taskChipSuggestions, setTaskChipSuggestions] = React.useState([]);
  const [horsePopoverBarnHorse, setHorsePopoverBarnHorse] = React.useState(null);

  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const mostUsedTaskTypesOfficial = useSelector((state) => state.board.mostUsedTaskTypes);
  const modalConfig = useSelector((state) => state.app.modalConfig);
  const hideSuggestions = !!modalConfig.hideSuggestions;

  const mostUsedTaskTypes = mostUsedTaskTypesOfficial.length >= 2
    ? mostUsedTaskTypesOfficial
    : allEventTemplates.filter((et) => (et.name === 'Flat Ride' || et.name === 'Hand Walk' || et.name === 'Turnout')).map((et) => et.id);

  React.useEffect(() => {
    if (hideSuggestions) { setTaskChipSuggestions([]); return; }
    if (planningMode && selectedDay) {
      const dayOfWeek = `${planningDayOfWeek}`;

      const hasSuggestion = boardSuggestionsKey && boardSuggestionsKey[dayOfWeek]
        && ((boardSuggestionsKey[dayOfWeek].suggestDayTrend
          && boardSuggestionsKey[dayOfWeek].suggestDayTrend.length > 0)
          || (boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend
            && boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend.length > 0)
          || (boardSuggestionsKey[dayOfWeek].suggestRecentTrend
            && boardSuggestionsKey[dayOfWeek].suggestRecentTrend.length > 0));

      const selectedSuggestion = hasSuggestion && {
        daySuggestion: boardSuggestionsKey[dayOfWeek],
        suggestion: boardSuggestionsKey.suggestion,
        dayOfWeek,
        barnHorse,
      }

      const dueDates = ((boardSuggestionsKey && boardSuggestionsKey.dueDates) || [])
        .map((dd) => ({
          ...dd.eventTemplateReminder.eventTemplate,
          title: `${breakUpCamelCase(dd.status)} Task Reminder`,
        }));

      let taskSuggestions = []
      const eventTemplatesMap = Object.assign({}, ...(allEventTemplates.map((i) => ({ [i.id]: i }))))
      if (selectedSuggestion) {
        if (selectedSuggestion && selectedSuggestion.daySuggestion) {
          const suggestDayTrend = selectedSuggestion.daySuggestion.suggestDayTrend
            && selectedSuggestion.daySuggestion.suggestDayTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestDayTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);

          let suggestMonthlyTrend = selectedSuggestion.daySuggestion.suggestMonthlyTrend
            && selectedSuggestion.daySuggestion.suggestMonthlyTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestMonthlyTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);
          suggestMonthlyTrend = suggestMonthlyTrend && suggestMonthlyTrend
            .filter((t) => !suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))

          let suggestRecentTrend = selectedSuggestion.daySuggestion.suggestRecentTrend
            && selectedSuggestion.daySuggestion.suggestRecentTrend.length > 0
            && selectedSuggestion.daySuggestion.suggestRecentTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
              .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
          suggestRecentTrend = suggestRecentTrend && suggestRecentTrend
            .filter((t) => (!suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))
              && (!suggestMonthlyTrend || !suggestMonthlyTrend.find((tt) => tt.id === t.id)))

          taskSuggestions = [...(suggestDayTrend || []).map((t) => ({
            ...t,
            title: `Questri Suggestion: Frequently Planned on ${getDayOfWeekFromNumber(selectedSuggestion.dayOfWeek)}`,
            suggestion: true,
          })),
          ...(suggestMonthlyTrend || []).map((t) => ({
            ...t,
            title: 'Questri Suggestion: Frequently Used',
            suggestion: true,
          })),
          ...(suggestRecentTrend || []).map((t) => ({
            ...t,
            title: 'Questri Suggestion: Frequently Planned Last 5 Days',
            suggestion: true,
          }))]
        }
      }
      taskSuggestions = [
        ...taskSuggestions,
        ...dueDates
          .filter((dd) => !taskSuggestions.find((ts) => ts.id === dd.id) && eventTemplatesMap[dd.id])
          .map((t) => ({
            ...t,
            suggestion: false,
            dueDate: true,
          })),
        ...mostUsedTaskTypes
          .filter((t) => !taskSuggestions.find((ts) => ts.id === t)
            && eventTemplatesMap[t] && !dueDates.find((dd) => dd.id === t) && eventTemplatesMap[t])
          .map((t) => ({
            ...eventTemplatesMap[t],
            title: 'Frequently Used',
            suggestion: false,
            dueDate: false,
          })),
      ].filter((t) => !overviewKey[selectedDay].find((i) => t.id === i.taskTypeId));
      setTaskChipSuggestions(sortBy(uniqBy(taskSuggestions, 'id'), 'name'))
    }
  }, [selectedDay, planningMode, boardSuggestionsKey, hideSuggestions])

  return (
    <TableRow
      className={classes.row}
      key={`task-item-${barnHorse.id}`}
      style={{
        borderLeft: `4px solid ${barnHorse.horse.activeNote
          ? getColorHexForImportance(barnHorse.horse.activeNote.importance, theme)
          : 'inherit'}`,
      }}
      onMouseEnter={() => { setHorsePopoverBarnHorse(true); }}
      onMouseLeave={() => { setHorsePopoverBarnHorse(false); }}
    >
      {!fullScreen && (
        <TableCell
          padding="none"
          sx={{ borderBottom: `2px solid ${primary[500]}` }}
        >
          <Checkbox
            color="primary"
            onChange={(event) => setSelectedBarnHorses(event.target.checked
              ? [...selectedBarnHorses, barnHorse.pingumTagId]
              : selectedBarnHorses.filter((t) => t !== barnHorse.pingumTagId))}
            checked={selectedBarnHorses.indexOf(barnHorse.pingumTagId) >= 0}
            inputProps={{ 'aria-labelledby': `barn-horse-row-checkbox-${barnHorse.id}` }}
          />
        </TableCell>
      )}
      <TableCell
        className={classes.cellSticky}
        sx={{
          minWidth: fullScreen && '90px !important',
          maxWidth: fullScreen && '90px !important',
          borderBottom: `2px solid ${primary[500]}`,
          backgroundColor: horsePopoverBarnHorse
            ? `${blueGrey[50]} !important`
            : undefined,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Horse
            size={36}
            horse={barnHorse.horse}
            hideShowName
            onClick={() => { dispatch(setSelectedBarnHorse(barnHorse)); }}
            clickable
            flexDirection={!fullScreen
              ? 'row'
              : 'column'}
            textWidth={fullScreen
              ? 90
              : 150}
          />
        </Box>
      </TableCell>
      {
        Object.keys(overviewKey)
          .filter((day) => !selectedDay || day === selectedDay).map((day) => {
            const dayAsDate = new Date(parseInt(day, 10));
            const dayOfWeek = moment(dayAsDate).day();

            const hasSuggestion = boardSuggestionsKey && boardSuggestionsKey[dayOfWeek]
              && ((boardSuggestionsKey[dayOfWeek].suggestDayTrend
                && boardSuggestionsKey[dayOfWeek].suggestDayTrend.length > 0)
                || (boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend
                  && boardSuggestionsKey[dayOfWeek].suggestMonthlyTrend.length > 0)
                || (boardSuggestionsKey[dayOfWeek].suggestRecentTrend
                  && boardSuggestionsKey[dayOfWeek].suggestRecentTrend.length > 0));

            const clickSelectTask = (calendarEventTab = false) => {
              const updatedSelectedBarnHorses = [...selectedBarnHorses
                .filter((t) => t !== barnHorse.pingumTagId), barnHorse.pingumTagId];
              setSelectedBarnHorses(updatedSelectedBarnHorses);

              const selectedSlot = {
                start: dayAsDate,
                end: new Date(dayAsDate.getTime() + 86400000), // mimicks an all day event
                barnHorses: updatedSelectedBarnHorses,
                callback: actionCompleteCallback,
                isHorseTask: true,
                calendarEventTab,
                dayOfWeek,
                selectedSuggestion: hasSuggestion && {
                  daySuggestion: boardSuggestionsKey[dayOfWeek],
                  suggestion: boardSuggestionsKey.suggestion,
                  dayOfWeek,
                  barnHorse,
                },
              };
              setSelectedSlot(selectedSlot);
              setOpenQuickSelectMenu(true);
            }
            return (
              <TableCell
                className={day.toString() === todayTimestamp.toString()
                  ? classes.cellHighlight
                  : (day < todayTimestamp
                    ? classes.cellPast
                    : classes.cell)}
                sx={{
                  minWidth: fullScreen && 'auto !important',
                  maxWidth: fullScreen && '0 !important',
                  position: 'relative',
                  borderWidth: '2px',
                  borderBottom: `2px solid ${primary[500]}`,
                  '&:hover': { background: blueGrey[50] },
                }}
                key={`table-row-${barnHorse.id}-${day}`}
                onClick={() => clickSelectTask(false)}
              >
                {
                  overviewKey[day] && overviewKey[day].length > 0 && (
                    <Box>
                      <TaskOverviewCell
                        items={overviewKey[day]}
                        onClick={handleOverviewItemClick}
                        onClickCalendarEvent={handleCalendarEventItemClick}
                        onTaskStateChange={handleOverviewItemTaskStateChangeClick}
                        today={day.toString() === todayTimestamp.toString()}
                        navigate={navigate}
                        inPast={day < todayTimestamp}
                        overrideShowAll={((!!planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))}
                        // showTime={((!!planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))}
                        showTime
                      />
                    </Box>
                  )
                }

                <Box
                  sx={{
                    height: overviewKey[day] && overviewKey[day].length <= 2
                      ? '33px'
                      : 0,
                  }}
                />
                {
                  !hideSuggestions && ((planningDayOfWeek && planningDayOfWeek === dayOfWeek) || (planningDayOfWeek === 0 && dayOfWeek === 0))
                  && (
                    <Box
                      sx={{ display: 'flex' }}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          ml: 4,
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: 1,
                            p: 1,
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            borderTopLeftRadius: 12,
                            borderTop: `1px dashed ${secondary[500]}`,
                            borderLeft: `1px dashed ${secondary[500]}`,
                            opacity: overviewKey[day].length > 0
                              ? '50%'
                              : undefined,
                          }}
                        >
                          {
                            taskChipSuggestions.map((taskType) => {
                              const clickTask = (e) => {
                                e.stopPropagation();
                                e.preventDefault();

                                const updatedSelectedBarnHorses = [...selectedBarnHorses
                                  .filter((t) => t !== barnHorse.pingumTagId), barnHorse.pingumTagId];
                                const selectedSlot = {
                                  start: dayAsDate,
                                  end: new Date(dayAsDate.getTime() + 86400000), // mimicks an all day event
                                  barnHorses: updatedSelectedBarnHorses,
                                  callback: actionCompleteCallback,
                                  isHorseTask: true,
                                  dayOfWeek,
                                  selectedSuggestion: hasSuggestion && {
                                    daySuggestion: boardSuggestionsKey[dayOfWeek],
                                    suggestion: boardSuggestionsKey.suggestion,
                                    dayOfWeek,
                                    barnHorse,
                                  },
                                  taskType,
                                }
                                handleOpenScheduleModal(taskType, false, selectedSlot)
                              }
                              return (

                                <Chip
                                  key={`task-chip-${taskType.id}`}
                                  sx={{
                                    border: '1px solid #CECECE',
                                    borderRadius: '6px',
                                    borderLeft: `6px solid ${(taskType.eventDataDefaultValues && taskType.eventDataDefaultValues.calendarDisplayColor) || primary[500]}`,
                                  }}
                                  size="small"
                                  variant="outlined"
                                  label={taskType.name}
                                  deleteIcon={(taskType.suggestion || taskType.dueDate)
                                    ? (
                                      <Tooltip
                                        disableInteractive
                                        title={taskType.title}
                                      >
                                        {
                                          taskType.dueDate
                                            ? (
                                              <NotificationsActive sx={{ color: '#F80058 !important' }} />
                                            )
                                            : (
                                              <AutoAwesome
                                                sx={{ color: '#FF6600 !important' }}
                                              />
                                            )
                                        }
                                      </Tooltip>
                                    )
                                    : undefined}
                                  onClick={clickTask}
                                  onDelete={((taskType.suggestion || taskType.dueDate) && clickTask) || undefined}
                                />
                              )
                            })
                          }

                          <Tooltip title="Select from list of tasks" placement="top" disableInteractive>
                            <Chip
                              sx={{
                                border: '1px solid #CECECE',
                                borderRadius: '6px',
                              }}
                              icon={<Task color="secondary" />}
                              size="small"
                              label={taskChipSuggestions.length > 0
                                ? 'Tasks'
                                : 'Select Task'}
                              variant="outlined"
                              deleteIcon={<Add color="secondary" />}
                              onClick={(e) => { e.stopPropagation(); clickSelectTask(false); }}
                              onDelete={(e) => { e.stopPropagation(); clickSelectTask(false); }}
                            />
                          </Tooltip>
                          <Tooltip title="Select from list of Calendars" placement="top" disableInteractive>
                            <Chip
                              sx={{
                                border: '1px solid #CECECE',
                                borderRadius: '6px',
                              }}
                              icon={<Today color="secondary" />}
                              size="small"
                              label="Calendars"
                              variant="outlined"
                              deleteIcon={<Add color="secondary" />}
                              onClick={(e) => { e.stopPropagation(); clickSelectTask(true); }}
                              onDelete={(e) => { e.stopPropagation(); clickSelectTask(true); }}
                            />
                          </Tooltip>

                          {
                            locationIndicator && (
                              <Tooltip title="This horse is currently located in more than one location">
                                <FmdBad
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(setSelectedBarnHorse(barnHorse));
                                  }}
                                  color="secondary"
                                  sx={{
                                    fontSize: '1.25rem !important',
                                    padding: '2px',
                                  }}
                                />
                              </Tooltip>
                            )
                          }
                        </Box>
                      </Box>
                    </Box>
                  )
                }
              </TableCell>
            )
          })
      }
    </TableRow>
  )
}, customComparator);
